import { theme } from 'component-library/utils';

export const SHARED_CHART_COLORS = {
  referenceLines: { stroke: '#0000004D', label: '#00000099' },
  confidenceIntervals: { fill: '#D5D5D5' },
  axis: { stroke: theme.colors?.['neutral-black-12'] as string },
} as const;
